import { render, staticRenderFns } from "./EditSectionComponents.vue?vue&type=template&id=2f435874&"
import script from "./EditSectionComponents.vue?vue&type=script&lang=js&"
export * from "./EditSectionComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f435874')) {
      api.createRecord('2f435874', component.options)
    } else {
      api.reload('2f435874', component.options)
    }
    module.hot.accept("./EditSectionComponents.vue?vue&type=template&id=2f435874&", function () {
      api.rerender('2f435874', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/SiteBuilder/components/EditSectionComponents.vue"
export default component.exports